/**
 * @file removeMutationHandler
 * @author yuzong(yuzong@tencent.com)
 */
import { MutationHandler } from '../lib/MutationHandler';
export var removeMutationHandler = MutationHandler.removeMutationHandler;